<button
  class="reset-button"
  [class.no-integration]="!integrationId"
  [disabled]="disabled || isLoading || !integrationId"
  (click)="resetAiiaIntegration()"
>
  <ng-container *ngIf="!isLoading; else loading">
    <span *ngIf="integrationId; else noInt">Nollställ Aiia-integration</span>
    <ng-template #noInt>Ingen Aiia-integration</ng-template>
  </ng-container>

  <ng-template #loading>Återställer...</ng-template>
</button>

<div *ngIf="successMessage" class="success">
  {{ successMessage }}
</div>

<div *ngIf="errorMessage" class="error">
  {{ errorMessage }}
</div>
